export const BADGE_CATEGORIES = {
  regularity: { label: "Régularité", color: "orange" },
  training: { label: "Entraînement", color: "blue" },
  nutrition: { label: "Nutrition", color: "green" },
  supplements: { label: "Compléments", color: "purple" },
  progress: { label: "Progression", color: "amber" },
  special: { label: "Spécial", color: "yellow" },
};

export const COACH_BADGE_CATEGORIES = {
  students: { label: "Élèves", color: "blue" },
  plans: { label: "Plans", color: "green" },
  sessions: { label: "Séances", color: "purple" },
  business: { label: "Business", color: "amber" },
  profile: { label: "Profil", color: "orange" },
  communication: { label: "Communication", color: "blue" },
  engagement: { label: "Engagement", color: "green" },
  special: { label: "Spécial", color: "yellow" },
};

export function badgeIconUrl(icon) {
  return `/badges/${icon || "first-checkin"}.svg`;
}

export function showBadgeUnlocks(badges, toast) {
  if (!Array.isArray(badges) || badges.length === 0) return;
  badges.forEach((badge) => {
    toast.success(`Badge débloqué : ${badge.title}`, {
      description: badge.description,
      duration: 5000,
    });
  });
}

/** Extrait new_badges d'une réponse API et affiche les toasts */
export function handleApiBadges(response, toast) {
  showBadgeUnlocks(response?.data?.new_badges, toast);
}

export function shareBadgeText(badge, userName) {
  const title = badge?.title || "Badge";
  return `${userName ? userName + " — " : ""}J'ai débloqué le badge « ${title} » sur MyCoaching ! 🏅`;
}

export function shareBadgeUrl(path = "/") {
  const base = typeof window !== "undefined" ? window.location.origin : "https://www.mycoaching.be";
  return `${base}${path}`;
}